<template>
  <div class="bg">
    <img
      class="backIcon"
      src="../assets/images/home/back.png"
      alt
      @click="goBack"
    />

    <div class="banner1">
      <img class="bannerBg" src="../assets/images/home/banner1.jpg" alt />

      <img
        class="recordIcon"
        @click="openRecord"
        src="../assets/images/home/recordIcon.png"
        alt
      />

      <img
        class="doubleIcon"
        @click="openDouble"
        src="../assets/images/home/doubleIcon.png"
        alt
      />
    </div>
    <div class="banner2">
      <div class="content">
        <!-- 按钮切换 -->
        <div class="tap">
          <div class="tapItem" @click="activeTab = 0">
            <img
              v-if="activeTab === 0"
              src="../assets/images/home/tab1_yes.png"
              alt=""
            />
            <img v-else src="../assets/images/home/tab1_no.png" alt="" />
          </div>

          <div class="tapItem" @click="activeTab = 1">
            <img
              v-if="activeTab === 1"
              src="../assets/images/home/tab2_yes.png"
              alt=""
            />
            <img v-else src="../assets/images/home/tab2_no.png" alt="" />
          </div>

          <div class="tapItem" @click="activeTab = 2">
            <img
              v-if="activeTab === 2"
              src="../assets/images/home/tab3_yes.png"
              alt=""
            />
            <img v-else src="../assets/images/home/tab3_no.png" alt="" />
          </div>
        </div>

        <!-- 登录按钮 -->
        <div class="loginBtn" v-if="!hasLogin" @click="openLogin">
          <img src="../assets/images/home/loginBtn.png" alt />
        </div>
        <!-- 会员信息 -->
        <div class="personInfo" v-if="hasLogin">
          <div class="personLi">
            <img class="vipIcon" src="../assets/images/home/vip.png" alt="" />
            <p>欢迎尊贵的会员：{{ vipAccount }}</p>
            <img
              class="logout"
              @click="logout"
              src="../assets/images/home/logout.png"
              alt=""
            />
          </div>

          <div class="personLi">
            <img
              class="moneyIcon"
              src="../assets/images/home/money.png"
              alt=""
            />
            <p>
              奖励累计获得：<span
                >{{ formatNumber(rechargeInfo.totalGet) }}元</span
              >
            </p>
          </div>

          <p class="myGift" @click="openMyGift">我的奖励></p>
        </div>

        <!-- 第一波现金池 -->
        <div class="recharge1" v-if="activeTab === 0">
          <div class="title1"></div>

          <div class="totalRecharge">
            <p class="totalRechargeText1" v-if="!hasLogin">登录查看</p>

            <p class="totalRechargeText2" v-if="hasLogin">
              {{ formatNumber(rechargeInfo.currentMoney) }}<span>波币</span>
            </p>
          </div>

          <div class="tier">
            <p class="tierText1" v-if="!hasLogin">登录查看</p>

            <p class="tierText2" v-if="hasLogin">
              {{ formatNumber(rechargeInfo.currentRule.valueCtl)
              }}<span>档</span>
            </p>
          </div>

          <div class="progressBar">
            <div
              class="progressBarLine"
              :style="{
                width: Math.max(0, NowRechargePorgress - 4) + '%',
              }"
            >
              <img
                class="progressArrow"
                src="../assets/images/home/progress_arrow.png"
                alt=""
              />
            </div>
          </div>

          <div class="bonus1">
            <div
              class="bonus1Li"
              v-for="(item, index) in rechargeRuleList"
              :key="index"
            >
              <div class="bonus1Get">
                <p class="title">可参与奖池</p>
                <p class="money">{{ item.minMoney }}-{{ item.maxMoney }}元</p>

                <p class="bonus1Add">{{ item.feName }}</p>

                <img
                  :class="[
                    'progressIcon',
                    rechargeRuleList.length == index + 1 ? 'last' : '',
                  ]"
                  src="../assets/images/home/progress_Icon.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div class="rechargeTips">
            <p v-if="!hasLogin">充值参与抽奖，赢取奖池大奖</p>
            <p v-if="hasLogin">
              距离下一档还差<span>{{ rechargeInfo.needMoney }}</span
              >波币
            </p>

            <div class="rechargeBtns">
              <!-- 未到时间 -->
              <img
                v-if="rechargeInfo.getStatus == 1"
                src="../assets/images/home/btn1.png"
                alt=""
              />

              <!-- 立即领取 -->
              <img
                v-if="rechargeInfo.getStatus == 2"
                @click="toGetRecharge('recharge')"
                src="../assets/images/home/btn2.png"
                alt=""
              />
              <!-- 已领取 -->
              <img
                v-if="rechargeInfo.getStatus == 3"
                src="../assets/images/home/btn3.png"
                alt=""
              />

              <!-- 已结束 -->
              <img
                v-if="rechargeInfo.getStatus == 4"
                src="../assets/images/home/btn4.png"
                alt=""
              />
            </div>
          </div>

          <div class="rechargeRule" @click="openRecharge1Alert"></div>
          <!-- 非结束状态就显示 -->
          <p class="rechargeTime" v-if="rechargeInfo.getStatus != 4">
            领取倒计时：{{ formatCountdown(rechargeInfo.countDown) }}
          </p>
        </div>

        <!-- 超级大奖池 -->
        <div class="superPrize" v-if="activeTab === 1">
          <div class="superPrizeInfo">
            <p class="superPrizeInfoText1">资格未达成</p>
            <p class="superPrizeInfoText2">
              我的机会：{{ superInfo.claimCount }}次
            </p>
            <!-- 未到时间 -->
            <div v-if="superInfo.getStatus == 1" class="superPrizeInfoBtn">
              <img src="../assets/images/home/text1.png" alt="" />
              <p class="superPrizeInfoText3">
                {{ formatCountdown(superInfo.countDown) }}
              </p>
            </div>
            <!-- 立即领取 -->
            <div
              v-if="superInfo.getStatus == 2"
              class="superPrizeInfoBtn"
              @click="toGetSuper"
            >
              <img src="../assets/images/home/text2.png" alt="" />
            </div>
            <!-- 已领取 -->
            <div v-if="superInfo.getStatus == 3" class="superPrizeInfoBtn">
              <img src="../assets/images/home/text3.png" alt="" />
            </div>
            <!-- 已结束 -->
            <div v-if="superInfo.getStatus == 4" class="superPrizeInfoBtn">
              <img src="../assets/images/home/text4.png" alt="" />
            </div>
          </div>

          <div class="superPrizeGift"></div>
        </div>

        <!-- 第二波现金池 -->
        <div class="recharge2" v-if="activeTab === 2">
          <div class="title2"></div>

          <div class="totalRecharge">
            <p class="totalRechargeText1" v-if="!hasLogin">登录查看</p>

            <p class="totalRechargeText2" v-if="hasLogin">
              {{ formatNumber(betting.currentMoney) }}
              <span>波币</span>
            </p>
          </div>

          <div class="tier">
            <p class="tierText1" v-if="!hasLogin">登录查看</p>

            <p class="tierText2" v-if="hasLogin">
              {{ formatNumber(betting.currentRule.valueCtl) }}<span>档</span>
            </p>
          </div>

          <div class="progressBar">
            <div
              class="progressBarLine"
              :style="{
                width: Math.max(0, NowBettingPorgress - 7) + '%',
              }"
            >
              <img
                class="progressArrow"
                src="../assets/images/home/progress_arrow.png"
                alt=""
              />
            </div>
          </div>

          <div class="bonus1">
            <div
              class="bonus1Li"
              v-for="(item, index) in bettingRuleList"
              :key="index"
            >
              <div class="bonus1Get">
                <p class="title">可参与奖池</p>
                <p class="money">{{ item.minMoney }}-{{ item.maxMoney }}元</p>

                <p class="bonus1Add">{{ item.feName }}</p>

                <img
                  :class="[
                    'progressIcon',
                    bettingRuleList.length == index + 1 ? 'last' : '',
                  ]"
                  src="../assets/images/home/progress_Icon.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div class="rechargeTips">
            <p v-if="!hasLogin">充值参与抽奖，赢取奖池大奖</p>
            <p v-if="hasLogin">
              距离下一档还差<span>{{ betting.needMoney }}</span
              >波币
            </p>

            <div class="rechargeBtns">
              <!-- 未到时间 -->
              <img
                v-if="betting.getStatus == 1"
                src="../assets/images/home/btn1.png"
                alt=""
              />
              <!-- 立即领取 -->
              <img
                @click="toGetRecharge('betting')"
                v-if="betting.getStatus == 2"
                src="../assets/images/home/btn2.png"
                alt=""
              />

              <!-- 已领取 -->
              <img
                v-if="betting.getStatus == 3"
                src="../assets/images/home/btn3.png"
                alt=""
              />

              <!-- 已结束 -->
              <img
                v-if="betting.getStatus == 4"
                src="../assets/images/home/btn4.png"
                alt=""
              />
            </div>
          </div>

          <div class="rechargeRule" @click="openRecharge2Alert"></div>
          <!-- 非结束状态就显示 -->
          <p class="rechargeTime" v-if="betting.getStatus != 4">
            领取倒计时：{{ formatCountdown(betting.countDown) }}
          </p>
        </div>

        <!-- 流程 -->
        <img class="process" src="../assets/images/home/process.png" alt="" />

        <!-- 规则 -->
        <img class="rule" src="../assets/images/home/rule.png" alt="" />
      </div>
    </div>

    <div class="banner3">
      <img class="bannerBg" src="../assets/images/home/banner3.jpg" alt />
    </div>

    <!-- 登录弹窗 -->
    <div class="login" v-if="!loginStatus">
      <div class="loginTips">
        <img src="../assets/images/home/loginAlert.png" alt />
        <div class="loginYes" @click="loginFunc"></div>
        <div class="loginClose" @click="closelogin"></div>
        <div class="tutorial" @click="toTutorial"></div>
        <div class="themeInput">
          <input
            type="text"
            v-model="vipAccount"
            placeholder="请输入您的APPID"
          />
        </div>
      </div>
    </div>

    <!-- appid获取教程 -->
    <div class="tutorialAlert" v-if="tutorialStatus">
      <div class="tutorialAlertTips">
        <img :src="getTutorialSrc()" alt />
        <div class="closeTutorialIcon" @click="closeTutorial"></div>
      </div>
    </div>

    <!-- 现金弹窗规则1 -->
    <div class="rechargeAlert" v-if="rechargeAlert1Status">
      <div class="rechargeAlertTips">
        <img src="../assets/images/home/rechargeAlert1.png" alt />

        <div class="bonus2">
          <div
            :class="['bonus2Li', 'bonus2Style' + (index + 1)]"
            v-for="(item, index) in rechargeRuleList"
            :key="index"
          >
            <p class="bonus2Add">{{ formatNumber(item.valueCtl) }}</p>
            <p class="bonus2Get">
              {{ item.minMoney }} - {{ item.maxMoney }}<span>元</span>
            </p>
          </div>
        </div>

        <div class="closeRechargeIcon1" @click="closeRecharge1Alert"></div>
      </div>
    </div>

    <!-- 现金弹窗规则2 -->
    <div class="rechargeAlert" v-if="rechargeAlert2Status">
      <div class="rechargeAlertTips">
        <img src="../assets/images/home/rechargeAlert2.png" alt />

        <div class="bonus3">
          <div
            :class="['bonus3Li', 'bonus3Style' + (index + 1)]"
            v-for="(item, index) in bettingRuleList"
            :key="index"
          >
            <p class="bonus3Add">{{ formatNumber(item.valueCtl) }}</p>
            <p class="bonus3Get">
              {{ item.minMoney }} - {{ item.maxMoney }}<span>元</span>
            </p>
          </div>
        </div>

        <div class="closeRechargeIcon2" @click="closeRecharge2Alert"></div>
      </div>
    </div>

    <!-- 我的奖励弹窗 -->
    <div class="myRewardAlert" v-if="myRewardAlertStatus">
      <div class="myRewardAlertTips">
        <img class="myRewardBg" src="../assets/images/home/giftAlert.png" alt />
        <p class="money">
          <span>￥</span>{{ formatNumber(superInfo.totalGet) }}
        </p>

        <div class="giftList">
          <!-- <div class="giftLi">
            <img src="../assets/images/home/gift_card1.png" alt="" />
          </div> -->
          <div
            class="giftLi"
            v-for="(item, index) in superRewards"
            :key="index"
          >
            <img src="../assets/images/home/gift_card2.png" alt="" />

            <p v-if="item.status == 1" class="giftCan">???</p>
            <div v-if="item.status == 1" class="giftLiBtn1">待开启</div>

            <div v-if="item.status == 2" class="giftLiBtn2" @click="toGetSuper">
              待领取
            </div>

            <p v-if="item.status == 3" class="giftCan">{{ item.money }}</p>
            <div v-if="item.status == 3" class="giftLiBtn1">已开启</div>
          </div>
          <div class="giftLi">
            <img src="../assets/images/home/gift_card3.png" alt="" />
          </div>
        </div>

        <div class="closeMyRewardIcon" @click="closeMyRewardAlert"></div>
      </div>
    </div>

    <!-- 神秘大奖弹窗 -->
    <div class="getBoxAlert" v-if="getBoxAlertStatus">
      <div class="getBoxAlertTips">
        <img src="../assets/images/home/getBoxAlert.png" alt />
        <div class="openGetBox" @click="openGetMoney"></div>
        <div class="closeGetBoxIcon" @click="closeGetBoxAlert"></div>
      </div>
    </div>

    <!-- 恭喜你弹窗 -->
    <div class="getMoneyAlert" v-if="getMoneyAlertStatus">
      <div class="getMoneyAlertTips">
        <img src="../assets/images/home/getMoneyAlert.png" alt />
        <p>
          获得<span>{{ moneyValue }}</span
          >元
        </p>
        <div class="openGetMoney" @click="closeGetMoneyAlert">我知道了</div>
        <div class="closeGetMoneyIcon" @click="closeGetMoneyAlert"></div>
      </div>
    </div>

    <!-- 超级列表弹窗 -->
    <div class="superListAlert" v-if="superListAlertStatus">
      <div class="superListAlertTips">
        <img src="../assets/images/home/double_list.png" alt />

        <ul class="superListAlertContent">
          <li v-for="item in superList" :key="item.id">
            <p class="superListTitle">超级大奖池超级加倍</p>
            <p class="superListMoney1">已成功领取{{ item.money }}元</p>
            <p class="superListMoney2">超级加倍后：{{ item.money }}元</p>
            <p class="superListTime">
              剩余{{ formatCountdown(item.countDown) }}
            </p>
            <div class="superListButton" @click="handleSuperListButton(item)">
              {{ superStatusObj[item.status] }}
            </div>
          </li>
        </ul>
        <div class="closeSuperListIcon" @click="closeSuperListAlert"></div>
      </div>
    </div>

    <!-- 超级领取弹窗 -->
    <div class="superGetAlert" v-if="superGetAlertStatus">
      <div class="superGetAlertTips">
        <img src="../assets/images/home/double_get.png" alt />
        <p class="superGetAlertMoney1">{{ moneyValue }}<span>元</span></p>
        <p class="superGetAlertX">x1</p>
        <p class="superGetAlertMoney2">{{ moneyValue }}<span>元</span></p>
        <p class="superGetAlertTime">
          {{ formatCountdown(superGetTimeV) }}后过期
        </p>

        <div class="openSuperGet" @click="openSuperGetFunc"></div>
        <div class="closeSuperGetIcon" @click="closeSuperGetAlert"></div>
      </div>
    </div>

    <!-- 超级领取成功弹窗 -->
    <div class="superGetSuccessAlert" v-if="superGetSuccessAlertStatus">
      <div class="superGetSuccessAlertTips">
        <img src="../assets/images/home/double_tips.png" alt />
        <p class="superGetSuccessAlertMoney">
          <span class="superGetSuccessAlertPlus">+</span>{{ nowSuperObj.money
          }}<span>元</span>
        </p>
        <div
          class="superGetSuccessAlertTip1"
          v-if="nowSuperObj.prepaidAmount > 0"
        >
          充值{{ nowSuperObj.prepaidAmount }}元
          <p>即可获得加倍奖励</p>
        </div>

        <div
          class="superGetSuccessAlertTip1"
          v-if="nowSuperObj.prepaidAmount == 0"
        >
          任意充值1次
          <p>即可获得加倍奖励</p>
        </div>
        <p class="superGetSuccessAlertTime">
          {{ formatCountdown(nowSuperObj.countDown) }}后过期
        </p>

        <div
          class="closeSuperGetSuccessIcon"
          @click="closeSuperGetSuccessAlert"
        ></div>
      </div>
    </div>

    <!-- 领取记录相关 -->
    <ReceiveRecords
      v-if="getRecordStatus"
      :vipAccount="vipAccount"
      @back="getRecordStatus = false"
    />
  </div>
</template>

<script>
import { Toast } from "vant";
import {
  getXjhgInfo,
  getXjhgGet,
  getXjhgMissions,
  getAcceptMission,
} from "@/api/index";
import {
  formatCountdown,
  startSingleCountdownTimer,
  clearSingleCountdownTimer,
  startListCountdownTimer,
  clearListCountdownTimer,
  formatNumber,
} from "@/utils/utils";
import ReceiveRecords from "@/components/record.vue";

export default {
  name: "HomeView",
  components: {
    ReceiveRecords,
  },

  data() {
    return {
      activeTab: 0,
      hasLogin: false,
      loginStatus: false,
      tutorialStatus: false,
      vipAccount: "",
      loginPointState: 0,
      rechargeStatus: 2,
      rechargeTimeStatus: 1,

      rechargeAlert1Status: false,
      rechargeAlert2Status: false,
      getRecordStatus: false,
      myRewardAlertStatus: false,
      getBoxAlertStatus: false,
      getMoneyAlertStatus: false,

      rechargeRuleList: [],
      bettingRuleList: [],
      rechargeInfo: {
        currentRule: {
          valueCtl: 0,
        },
      },
      superInfo: {},
      betting: {
        currentRule: {
          valueCtl: 0,
        },
      },
      maxRechargeValue: 0,
      maxBettingValue: 0,
      moneyValue: 0,
      NowRechargePorgress: 0,
      NowBettingPorgress: 0,
      superRewards: [],
      superListAlertStatus: false,
      superGetAlertStatus: false,
      superGetSuccessAlertStatus: false,
      superGetTimeV: null,
      superList: [],
      superStatusObj: {
        0: "立即加倍",
        1: "已接受",
        2: "已完成",
        3: "已过期",
      },
      nowSuperObj: {
        countDown: 0,
        money: 0,
        prepaidAmount: 0,
      },
    };
  },

  mounted() {
    this.getXjhgInfoFunc();

    // 检查 URL 参数中是否有 vipAccount，如果有则自动登录
    const vipAccountFromUrl = this.$route.query.vipAccount;
    if (vipAccountFromUrl) {
      this.vipAccount = vipAccountFromUrl;
      this.loginFunc();
    }
  },
  computed: {},
  beforeDestroy() {
    clearSingleCountdownTimer(this, "rechargeCountDownTimer");
    clearSingleCountdownTimer(this, "superCountDownTimer");
    clearSingleCountdownTimer(this, "bettingCountDownTimer");
    clearListCountdownTimer(this, "superListCountDownTimer");
  },

  methods: {
    formatCountdown,
    formatNumber,
    // 根据appid获取教程图
    getTutorialSrc() {
      const appId = this.$route.query.appId;
      return `images/tutorial/${appId}.png`;
    },
    // 获取登录前信息
    async getXjhgInfoFunc() {
      const res1 = await getXjhgInfo({
        type: "recharge",
      });

      this.rechargeRuleList = res1.data.rules;
      this.rechargeInfo = res1.data.info;

      const res2 = await getXjhgInfo({
        type: "super",
      });
      this.superInfo = res2.data.info;

      const res3 = await getXjhgInfo({
        type: "betting",
      });
      this.bettingRuleList = res3.data.rules;
      this.betting = res3.data.info;

      // 领取倒计时
      startSingleCountdownTimer(
        this,
        "rechargeInfo.countDown",
        "rechargeCountDownTimer",
      );
      startSingleCountdownTimer(
        this,
        "superInfo.countDown",
        "superCountDownTimer",
      );
      startSingleCountdownTimer(
        this,
        "betting.countDown",
        "bettingCountDownTimer",
      );
    },
    // 获取登录后信息
    async getXjhgInfoFuncAfter(isLogin) {
      const res1 = await getXjhgInfo({
        type: "recharge",
        appId: this.$route.query.appId,
        username: this.vipAccount,
      });
      this.rechargeInfo = res1.data.info;

      this.updateProgress({
        listProp: "rechargeRuleList",
        currPath: "rechargeInfo.currentRule.valueCtl",
        outProp: "NowRechargePorgress",
      });

      const res2 = await getXjhgInfo({
        type: "super",
        appId: this.$route.query.appId,
        username: this.vipAccount,
      });
      this.superInfo = res2.data.info;
      this.superRewards = res2.data.info.superRewards;

      const res3 = await getXjhgInfo({
        type: "betting",
        appId: this.$route.query.appId,
        username: this.vipAccount,
      });
      this.betting = res3.data.info;

      this.updateProgress({
        listProp: "bettingRuleList",
        currPath: "betting.currentRule.valueCtl",
        outProp: "NowBettingPorgress",
      });

      // 如果是登录 就执行关闭登录弹窗
      if (isLogin) {
        this.hasLogin = true;
        this.loginStatus = true;
      }
    },

    updateProgress({ listProp, currPath, outProp, field = "valueCtl" } = {}) {
      const getByPath = (obj, path) => {
        if (!obj || !path) return undefined;
        return String(path)
          .split(".")
          .reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
      };

      const list = this[listProp];
      const arr = Array.isArray(list) ? list : [];
      const len = arr.length;
      if (!len) {
        this[outProp] = 0;
        return;
      }

      const curr = Number(getByPath(this, currPath));
      const idx = arr.findIndex((it) => Number(it && it[field]) === curr);
      this[outProp] = idx >= 0 ? ((idx + 1) / len) * 100 : 0;
    },

    // 登录
    async loginFunc() {
      if (!this.vipAccount) {
        Toast({ message: "请输入您的ID！", duration: 5 * 1000 });
        return false;
      }

      this.getXjhgInfoFuncAfter(true);
    },
    // 充值和投注现金池领取
    async toGetRecharge(type) {
      const res = await getXjhgGet({
        type: type,
        appId: this.$route.query.appId,
        username: this.vipAccount,
      });

      if (res.code == 0) {
        // 判断是不是符合加倍领取
        if (res.data.isMission) {
          this.superGetAlertStatus = true;
          this.superGetTimeV = res.data.missionCountDown;

          startSingleCountdownTimer(this, "superGetTimeV", "superGetTimer");
        } else {
          this.getMoneyAlertStatus = true;
        }
        this.moneyValue = res.data.money;

        this.getXjhgInfoFuncAfter(false);
      } else {
        Toast({ message: res.msg, duration: 2 * 1000 });
      }
      console.log(res);
    },
    // 超级大奖池 领取
    async toGetSuper() {
      const res = await getXjhgGet({
        type: "super",
        appId: this.$route.query.appId,
        username: this.vipAccount,
      });

      if (res.code == 0) {
        this.getBoxAlertStatus = true;
        this.moneyValue = res.data.money;

        this.getXjhgInfoFuncAfter(false);
      } else {
        Toast({ message: res.msg, duration: 2 * 1000 });
      }
      console.log(res);
    },
    // 加倍列表
    async getXjhgMissionsFunc() {
      const res = await getXjhgMissions({
        appId: this.$route.query.appId,
        username: this.vipAccount,
      });
      this.superList = (res.data || []).map((item) => ({
        ...item,
        countDown: item.countDown ?? item.countdown ?? 0,
      }));

      clearListCountdownTimer(this, "superListCountDownTimer");
      startListCountdownTimer(
        this,
        ["superList"],
        "countDown",
        "superListCountDownTimer",
      );
      console.log(res);
    },
    // 打开神秘大奖
    openGetMoney() {
      this.getBoxAlertStatus = false;
      this.getMoneyAlertStatus = true;
    },
    // 点击立即加倍按钮
    handleSuperListButton(item) {
      // 加倍状态才能点击
      if (item.status == 0) {
        this.nowSuperObj = item;

        this.superListAlertStatus = false;
        this.superGetSuccessAlertStatus = true;
      }
    },
    // 打开超级加倍
    openSuperGetFunc() {
      getAcceptMission({
        appId: this.$route.query.appId,
        username: this.vipAccount,
      }).then((res) => {
        if (res.code == 0) {
          this.superGetAlertStatus = false;
          this.superGetSuccessAlertStatus = true;
          this.nowSuperObj = res.data;
          clearSingleCountdownTimer(this, "superGetCountDownTimer");
          startSingleCountdownTimer(
            this,
            "nowSuperObj.countDown",
            "superGetCountDownTimer",
          );
        } else {
          Toast({ message: res.msg, duration: 2 * 1000 });
        }
      });
    },
    // 登出
    logout() {
      this.loginStatus = false;
      this.hasLogin = false;
      this.vipAccount = "";

      this.NowRechargePorgress = 0;
      this.NowBettingPorgress = 0;

      this.getXjhgInfoFunc();
    },

    // 返回上一页
    goBack() {
      if (this.$route.query.vipAccount) {
        window.history.back();
      }
    },
    openLogin() {
      this.loginStatus = false;
    },
    closelogin() {
      this.loginStatus = true;
    },
    // 打开教程图
    toTutorial() {
      this.tutorialStatus = true;
      this.loginAlert = false;
    },
    // 打开记录
    openRecord() {
      this.getRecordStatus = true;
    },
    // 打开我的奖励
    openMyGift() {
      this.myRewardAlertStatus = true;
    },
    openRecharge1Alert() {
      this.rechargeAlert1Status = true;
    },
    openRecharge2Alert() {
      this.rechargeAlert2Status = true;
    },

    // 打开超级加倍列表
    openDouble() {
      this.superListAlertStatus = true;
      this.getXjhgMissionsFunc();
    },
    closeTutorial() {
      this.tutorialStatus = false;
    },
    closeRecharge1Alert() {
      this.rechargeAlert1Status = false;
    },
    closeRecharge2Alert() {
      this.rechargeAlert2Status = false;
    },
    closeMyRewardAlert() {
      this.myRewardAlertStatus = false;
    },
    closeGetBoxAlert() {
      this.getBoxAlertStatus = false;
    },
    closeGetMoneyAlert() {
      this.getMoneyAlertStatus = false;
    },
    closeSuperListAlert() {
      this.superListAlertStatus = false;
    },
    closeSuperGetAlert() {
      this.superGetAlertStatus = false;
    },
    closeSuperGetSuccessAlert() {
      this.superListAlertStatus = true;
      this.superGetSuccessAlertStatus = false;
      this.getXjhgMissionsFunc();
    },
  },
};
</script>

<style scoped lang="less">
.bg {
  position: relative;
}

.backIcon {
  width: 39px;
  height: 39px;
  position: absolute;
  left: 15px;
  top: 15px;
  z-index: 1;
}

.banner1 {
  width: 100%;
  height: auto;
  position: relative;
  .bannerBg {
    width: 100%;
    height: auto;
  }

  .ruleIcon {
    width: 49px;
    height: 49px;
    position: absolute;
    right: 10px;
    top: 53px;
  }
  .recordIcon {
    width: 87px;
    height: 32px;
    position: absolute;
    right: 0;
    top: 312px;
  }

  .doubleIcon {
    width: 87px;
    height: 37px;
    position: absolute;
    right: 0;
    top: 360px;
  }
}

.banner2 {
  background: url("../assets/images/home/banner2.png") no-repeat center center;
  background-size: 100% 100%;
  width: 100%;
  height: auto;
  position: relative;
  z-index: 3;
  margin: -558px 0px;

  .content {
    width: 100%;
    position: relative;
    margin-top: -200px;
    transform: translate(0, -111px);
  }
}

.banner3 {
  width: 100%;
  height: auto;
  position: relative;
  .bannerBg {
    width: 100%;
    height: auto;
  }
}

.loginBtn {
  width: 455px;
  height: 57px;
  margin: 33px auto 0;
  img {
    width: 100%;
    height: 100%;
  }
}

.personInfo {
  background: url("../assets/images/home/vip_bg.png") no-repeat center center;
  background-size: 100% 100%;
  width: 507px;
  height: 101px;
  margin: 22px auto -11px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .personLi {
    display: flex;
    align-items: center;
    margin: 4px 0 4px 29px;
    p {
      font-size: 16px;
      color: #570803;
      margin-left: 5px;
      span {
        color: #e62b17;
        font-size: 22px;
        font-weight: bold;
      }
    }
    .vipIcon {
      width: 26px;
    }
    .moneyIcon {
      width: 22px;
    }
    .logout {
      width: 73px;
      margin-left: 10px;
    }
  }

  .myGift {
    font-size: 14px;
    position: absolute;
    bottom: 15px;
    right: 20px;
    color: #570803;
  }
}

.tap {
  display: flex;
  width: calc(100% - 78px);
  justify-content: space-between;
  margin: 0 auto;
  .tapItem {
    img {
      width: 100px;
      height: 100px;
    }
  }
}

.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 4;
  .loginTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 462px;
    }
    .loginYes {
      position: absolute;
      left: 78px;
      bottom: 123px;
      width: 304px;
      height: 60px;
      cursor: pointer;
      border-radius: 12px;
    }
    .loginClose {
      position: absolute;
      right: 12px;
      top: 63px;
      width: 45px;
      height: 45px;
      cursor: pointer;
      border-radius: 12px;
    }
    .tutorial {
      position: absolute;
      left: 254px;
      bottom: 79px;
      width: 80px;
      height: 22px;
    }
    .themeInput {
      position: absolute;
      top: 241px;
      left: 50%;
      width: 263px;
      transform: translate(-50%, 0);
      input {
        background: none;
        border: 0;
        color: #702a18;
        font-size: 19px;
        width: 220px;
        text-align: center;
        &::placeholder {
          color: #702a18;
          font-size: 19px;
        }
      }
      input[type="text"]:focus {
        outline: none;
      }
    }
  }
}

.recharge1,
.recharge2 {
  width: 530px;
  height: 464px;
  margin: 10px auto 0;
  z-index: 8;
  position: relative;

  .title1 {
    background: url("../assets/images/home/recharge_bg_title.png") no-repeat
      center center;
    background-size: 100% 100%;
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 420px;
    height: 57px;
  }

  .title2 {
    background: url("../assets/images/home/recharge_bg_title2.png") no-repeat
      center center;
    background-size: 100% 100%;
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 420px;
    height: 57px;
  }

  .totalRecharge {
    position: absolute;
    top: 160px;
    left: 67px;
    .totalRechargeText1 {
      color: #c20c0c;
      font-size: 18px;
      font-weight: bold;
    }
    .totalRechargeText2 {
      color: #c20c0c;
      font-size: 41px;
      font-weight: bold;
      margin-top: -8px;
      span {
        font-size: 16px;
        color: #7e2009;
        margin-left: 5px;
      }
    }
  }

  .tier {
    position: absolute;
    top: 160px;
    left: 359px;
    .tierText1 {
      color: #7e2009;
      font-size: 18px;
    }
    .tierText2 {
      color: #7e2009;
      font-size: 30px;
      margin-top: -8px;
      font-weight: bold;
      span {
        font-size: 17px;
        margin-left: 5px;
      }
    }
  }

  .progressBar {
    position: absolute;
    top: 209px;
    left: 55px;
    width: 420px;
    .progressBarLine {
      background: url("../assets/images/home/progress_bar.png") no-repeat center
        center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      height: 10px;
      width: 0;
      position: relative;

      .progressArrow {
        width: 30px;
        height: 30px;
        position: absolute;
        top: -10px;
        right: -11px;
        z-index: 1;
      }
    }
  }
  .bonus1 {
    display: flex;
    position: absolute;
    left: 53px;
    top: 236px;
    width: 432px;
    justify-content: space-between;
    .bonus1Li {
      position: relative;
      text-align: right;

      .bonus1Get {
        margin-top: 16px;
        background: url("../assets/images/home/recharge_money.png") no-repeat
          center center;
        background-size: 100% 100%;
        height: 52px;
        padding: 0 5px;
        display: inline-block;
        position: relative;
        .title {
          color: #fff;
          font-size: 10px;
          padding-top: 18px;
          text-align: center;
        }
        .money {
          background: linear-gradient(to bottom, #fdfff3, #fce77e);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          font-weight: bold;
          font-size: 11px;
          text-align: center;
        }

        .bonus1Add {
          color: #420f00;
          font-size: 14px;
          position: absolute;
          top: -20px;
          left: 50%;
          transform: translate(-50%, 0);
          white-space: nowrap;
        }

        .progressIcon {
          width: 7px;
          height: 8px;
          position: absolute;
          left: 50%;
          top: -34px;
          transform: translate(-50%, 0);
        }

        .progressIcon.last {
          right: 10px;
          left: unset;
        }
      }
    }

    // .bonus1Style2 {
    //   margin-left: 19px;
    // }

    // .bonus1Style3 {
    //   margin-left: 36px;
    // }

    // .bonus1Style4 {
    //   margin-left: 29px;
    // }

    // .bonus1Style5 {
    //   margin-left: 28px;
    // }
  }

  .rechargeTips {
    position: absolute;
    top: 330px;
    left: 50%;
    transform: translate(-50%, 0);
    color: #7e2009;
    font-size: 18px;
    display: flex;
    width: calc(100% - 92px);
    justify-content: space-between;
    align-items: center;
    p {
      font-size: 15px;
      margin-left: 20px;
      span {
        color: #bd1208;
        font-size: 21px;
        font-weight: bold;
      }
    }

    .rechargeBtns {
      img {
        width: 170px;
      }
    }
  }

  .rechargeRule {
    width: 120px;
    height: 34px;
    position: absolute;
    bottom: 31px;
    left: 59px;
  }

  .rechargeTime {
    color: #fff;
    position: absolute;
    bottom: 38px;
    right: 54px;
    font-size: 14px;
  }
}

.recharge1 {
  background: url("../assets/images/home/recharge_bg.png") no-repeat center
    center;
  background-size: 100% 100%;
}

.recharge2 {
  background: url("../assets/images/home/recharge_bg2.png") no-repeat center
    center;
  background-size: 100% 100%;
}

.superPrize {
  .superPrizeInfo {
    background: url("../assets/images/home/pool1_bg.png") no-repeat center
      center;
    background-size: 100% 100%;
    width: 525px;
    height: 286px;
    margin: 16px auto 0;
    position: relative;
    .superPrizeInfoBtn {
      position: absolute;
      left: 338px;
      top: 121px;
      width: 117px;
      display: flex;
      justify-content: center;
      height: 50px;
      align-items: center;
      flex-direction: column;
      img {
        height: 27px;
      }
    }

    .superPrizeInfoText1 {
      font-size: 12px;
      color: #fcf8d8;
      text-align: center;
      position: absolute;
      left: 367px;
      top: 58px;
    }
    .superPrizeInfoText2 {
      font-size: 12px;
      color: #fff;
      text-align: center;
      position: absolute;
      left: 360px;
      top: 79px;
    }

    .superPrizeInfoText3 {
      font-size: 11px;
      color: #fff;
      text-align: center;
    }
  }
  .superPrizeGift {
    background: url("../assets/images/home/pool2_bg.png") no-repeat center
      center;
    background-size: 100% 100%;
    width: 496px;
    height: 320px;
    margin: 16px auto 14px;
  }
}

.process {
  width: 527px;
  margin-top: 16px;
}

.rule {
  width: 534px;
  margin-top: 16px;
}

.tutorialAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .tutorialAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 500px;
    }
    .tutorialAlertYes {
      position: absolute;
      left: 76px;
      bottom: 144px;
      width: 248px;
      height: 62px;
      cursor: pointer;
      border-radius: 12px;
    }
    .closeTutorialIcon {
      position: absolute;
      right: 14px;
      top: 12px;
      width: 40px;
      height: 40px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.rechargeAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .rechargeAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 500px;
    }

    .bonus2 {
      position: absolute;
      left: 131px;
      top: 146px;
      .bonus2Li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 33px;
        .bonus2Add {
          color: #6a1802;
          font-size: 25px;
          width: 105px;
          font-weight: bold;
          span {
            font-size: 13px;
            margin-left: 3px;
          }
        }
        .bonus2Get {
          font-size: 25px;
          width: 139px;
          font-weight: bold;
          margin-left: 53px;
          white-space: nowrap;
          span {
            font-size: 13px;
            margin-left: 3px;
          }
        }
      }

      .bonus2Style1 {
        .bonus2Get {
          color: #004b00;
        }
      }

      .bonus2Style2 {
        .bonus2Get {
          color: #0757a0;
        }
      }

      .bonus2Style3 {
        .bonus2Get {
          color: #6a1b86;
        }
      }

      .bonus2Style4 {
        .bonus2Get {
          color: #d14800;
        }
      }

      .bonus2Style5 {
        .bonus2Get {
          color: #c51814;
        }
      }
    }

    .bonus3 {
      position: absolute;
      left: 33px;
      top: 180px;
      display: flex;
      width: 432px;
      flex-wrap: wrap;
      justify-content: space-between;
      .bonus3Li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 93px;
        flex-direction: column;
        width: 205px;
        .bonus3Add {
          color: #b00f07;
          font-size: 25px;
          width: 100%;
          font-weight: bold;
        }
        .bonus3Get {
          font-size: 24px;
          font-weight: bold;
          margin-top: 27px;
          width: 100%;
          color: #b00f07;
          span {
            font-size: 13px;
          }
        }
      }
    }
    .closeRechargeIcon1 {
      position: absolute;
      right: -2px;
      top: 12px;
      width: 45px;
      height: 45px;
      cursor: pointer;
      border-radius: 25px;
    }
  }

  .closeRechargeIcon2 {
    position: absolute;
    right: 16px;
    top: 12px;
    width: 45px;
    height: 45px;
    cursor: pointer;
    border-radius: 25px;
  }
}

.myRewardAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .myRewardAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    .myRewardBg {
      width: 500px;
    }

    .money {
      transform: translate(-50%, 0);
      position: absolute;
      left: 50%;
      top: 131px;
      background: linear-gradient(to bottom, #fdfff3, #fce77e);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      font-size: 74px;
      font-weight: bold;
      filter: drop-shadow(0 4px 2px rgba(0, 0, 0, 0.4));
      margin-left: -15px;
      span {
        font-size: 32px;
      }
    }

    .giftList {
      position: absolute;
      left: 40px;
      top: 269px;
      display: flex;
      align-items: center;
      gap: 7px;
      justify-content: center;
      .giftLi {
        position: relative;
        img {
          height: 165px;
        }

        .giftCan {
          position: absolute;
          left: 50%;
          bottom: 45px;
          transform: translate(-50%, 0);
          color: #e1443b;
          font-size: 17px;
          font-weight: bold;
          letter-spacing: 4px;
        }

        .giftLiBtn1 {
          position: absolute;
          left: 50%;
          bottom: 19px;
          transform: translate(-50%, 0);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #7d3409;
          font-size: 14px;
          background: #fdd192;
          border-radius: 12px;
          padding: 3px 17px;
          word-break: keep-all;
        }

        .giftLiBtn2 {
          position: absolute;
          left: 50%;
          bottom: 19px;
          transform: translate(-50%, 0);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 14px;
          background: #e1443b;
          border-radius: 12px;
          padding: 3px 17px;
          word-break: keep-all;
        }
      }
    }

    .closeMyRewardIcon {
      position: absolute;
      right: 15px;
      top: 36px;
      width: 40px;
      height: 40px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.getBoxAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .getBoxAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 500px;
    }

    .openGetBox {
      position: absolute;
      left: 126px;
      bottom: 39px;
      width: 267px;
      height: 58px;
    }

    .closeGetBoxIcon {
      position: absolute;
      right: -2px;
      top: 4px;
      width: 50px;
      height: 50px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.getMoneyAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .getMoneyAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 500px;
    }

    p {
      font-size: 40px;
      position: absolute;
      left: 132px;
      top: 202px;
      background: linear-gradient(to bottom, #ff5c58, #880201);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      width: 256px;
      font-weight: bold;
      span {
        font-size: 69px;
      }
    }

    .openGetMoney {
      position: absolute;
      left: 132px;
      bottom: 48px;
      width: 228px;
      height: 58px;
      display: flex;
      font-size: 20px;
      font-weight: bold;
      justify-content: center;
      line-height: 57px;
      background: linear-gradient(to bottom, #fdfff3, #fce77e);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    }

    .closeGetMoneyIcon {
      position: absolute;
      right: 16px;
      top: 28px;
      width: 43px;
      height: 43px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.superListAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .superListAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 470px;
    }

    .superListAlertContent {
      position: absolute;
      left: 23px;
      top: 107px;
      height: 427px;
      overflow-y: auto;
      li {
        background: url("../assets/images/home/double_li.png") no-repeat center
          center;
        background-size: 100% 100%;
        width: 431px;
        height: 98px;
        margin-bottom: 8px;
        position: relative;

        .superListTitle {
          position: absolute;
          top: 16px;
          left: 109px;
          color: #aa0813;
          font-size: 17px;
        }
        .superListMoney1 {
          position: absolute;
          top: 41px;
          left: 109px;
          color: #2b1500;
          font-size: 12px;
        }
        .superListMoney2 {
          position: absolute;
          top: 67px;
          left: 109px;
          color: #fff69c;
          font-size: 14px;
        }
        .superListTime {
          position: absolute;
          bottom: 16px;
          right: 3px;
          color: #5f1f04;
          font-size: 12px;
          width: 109px;
          text-align: center;
        }
        .superListButton {
          position: absolute;
          top: 30px;
          right: 4px;
          color: #bc0904;
          font-weight: bold;
          font-size: 16px;
          width: 106px;
          text-align: center;
        }
      }
    }

    .closeSuperListIcon {
      position: absolute;
      left: 211px;
      bottom: 3px;
      width: 47px;
      height: 47px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.superGetAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .superGetAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 490px;
    }

    .superGetAlertMoney1 {
      position: absolute;
      left: 43px;
      top: 420px;
      color: #8c3404;
      font-size: 37px;
      font-weight: bold;
      width: 160px;
      text-align: center;
      span {
        font-size: 15px;
      }
    }
    .superGetAlertX {
      position: absolute;
      left: 209px;
      top: 398px;
      background: linear-gradient(to bottom, #fd8a39, #de2b0a);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      font-size: 57px;
      font-weight: bold;
      font-family: emoji;
      filter: drop-shadow(1px 0 0 #fff) drop-shadow(-1px 0 0 #fff)
        drop-shadow(0 1px 0 #fff) drop-shadow(0 -1px 0 #fff)
        drop-shadow(1px 1px 0 #fff) drop-shadow(-1px 1px 0 #fff)
        drop-shadow(1px -1px 0 #fff) drop-shadow(-1px -1px 0 #fff);
    }
    .superGetAlertMoney2 {
      position: absolute;
      left: 279px;
      top: 413px;
      color: #eb2814;
      font-size: 50px;
      font-weight: bold;
      width: 160px;
      text-align: center;
      span {
        font-size: 18px;
      }
    }
    .superGetAlertTime {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 17px;
      font-size: 14px;
      color: #832f01;
    }
    .openSuperGet {
      position: absolute;
      left: 100px;
      bottom: 38px;
      width: 301px;
      height: 60px;
    }

    .closeSuperGetIcon {
      position: absolute;
      right: 9px;
      top: 115px;
      width: 43px;
      height: 43px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.superGetSuccessAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .superGetSuccessAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 517px;
    }

    .superGetSuccessAlertMoney {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      top: 132px;
      font-size: 122px;
      font-weight: bold;
      font-style: italic;
      width: 360px;
      text-align: center;
      background: linear-gradient(to bottom, #ff4b42, #c11712);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      .superGetSuccessAlertPlus {
        display: inline-block;
        transform: skewX(-10deg);
        background: linear-gradient(to bottom, #ff4b42, #c11712);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        font-size: 110px;
      }
      span {
        font-size: 48px;
      }
    }

    .superGetSuccessAlertTip1 {
      position: absolute;
      left: 81px;
      top: 266px;
      font-size: 25px;
      color: #4b1e00;
      display: flex;
      align-items: center;
      font-weight: bold;
      font-style: italic;
      word-break: keep-all;
      width: 370px;
      justify-content: center;
      p {
        background: linear-gradient(to bottom, #ff4b42, #c11712);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        padding: 0 5px;
      }
    }

    .superGetSuccessAlertTime {
      position: absolute;
      left: 208px;
      top: 400px;
      font-size: 14px;
      color: #cf1608;
    }

    .closeSuperGetSuccessIcon {
      position: absolute;
      right: 42px;
      top: 106px;
      width: 57px;
      height: 57px;
      cursor: pointer;
      border-radius: 25px;
      z-index: 2;
    }
  }
}
</style>
